import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import ContainerDimensions from 'react-container-dimensions';
import { PortalTeamCarousel } from './PortalTeamCarousel';
import './PortalTeam.scss';

// eslint-disable-next-line react/prefer-stateless-function
export class PortalTeam extends React.Component {
  static displayName = 'PortalTeam';

  static propTypes = {
    anchor: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    teamData: ImmutablePropTypes.listOf(
      ImmutablePropTypes.mapContains({
        fullName: PropTypes.string.isRequired,
        profileName: PropTypes.string.isRequired,
        profileLink: PropTypes.string.isRequired,
        profileSummary: PropTypes.string.isRequired,
      })
    ).isRequired,
    defaultProfileSummary: PropTypes.string.isRequired,
  };

  render() {
    const { anchor, title, teamData, defaultProfileSummary } = this.props;

    return (
      <portal-team id={anchor}>
        <div className="row portal-section">
          <div className="columns small-11 small-centered medium-10 medium-centered">
            <h2>{title}</h2>
            <ContainerDimensions>
              {({ width }) => (
                <PortalTeamCarousel
                  {...{ teamData, defaultProfileSummary, width }}
                />
              )}
            </ContainerDimensions>
          </div>
        </div>
      </portal-team>
    );
  }
}
